<span *ngIf="pillBlock_item">
    <div class="pills-blq pill-list">
        <a [routerLink]="['/pills',pillBlock_item.id]" class="w-100" title="{{pillBlock_item.title}}">
            <div class="col-lg-12 pills-blq-inner">
                <div class="overlay-pills"></div>
                <img [src]="img" alt="{{pillBlock_item.title}}" />
                <div class="play-pills">
                    <svg width="40" height="40" alt="foto video pills" viewBox="0 0 40 40" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M36.6666 20C36.6666 10.8105 29.1902 3.33333 19.9999 3.33333C10.8097 3.33333 3.33325 10.8105 3.33325 20C3.33325 29.1895 10.8097 36.6667 19.9999 36.6667C29.1902 36.6667 36.6666 29.1895 36.6666 20ZM4.99992 20C4.99992 11.7285 11.7292 5 19.9999 5C28.2706 5 34.9999 11.7285 34.9999 20C34.9999 28.2715 28.2706 35 19.9999 35C11.7292 35 4.99992 28.2715 4.99992 20ZM14.5824 11.613C14.7974 11.4882 15.0531 11.4685 15.2816 11.5502L15.415 11.6113L28.7483 19.2773C29.0071 19.4255 29.1666 19.7021 29.1666 20C29.1666 20.2482 29.0558 20.4817 28.8691 20.6384L28.7483 20.7227L15.415 28.3887C15.2864 28.4619 15.1431 28.4993 14.9999 28.4993C14.8559 28.4993 14.7118 28.4619 14.5824 28.387C14.3681 28.2636 14.2222 28.052 14.1795 27.8126L14.1666 27.666V12.334C14.1666 12.0361 14.3253 11.7611 14.5824 11.613ZM26.6617 20L15.8333 26.2256V13.7744L26.6617 20Z" />
                    </svg>

                </div>

            </div>


            <div class="content-pills">
                <div class="content-pills-title">
                    <p class="fw-bold dark">{{pillBlock_item.title}}</p>
                </div>

            </div>
        </a>
    </div>
</span>